import styles from './abtoggle.module.scss';

interface ABToggleProps {
  version: 'v1' | 'v2';
  onToggle: () => void;
}

const ABToggle: React.FC<ABToggleProps> = ({ version, onToggle }) => {
  return (
    <div className={styles.root}>
      <span className={styles.label}>hero</span>
      <button className={styles.toggle} onClick={onToggle} title="Toggle hero version">
        <span className={version === 'v1' ? styles.active : styles.inactive}>v1</span>
        <span className={styles.divider}>/</span>
        <span className={version === 'v2' ? styles.active : styles.inactive}>v2</span>
      </button>
    </div>
  );
};

export default ABToggle;
